export default __webpack_public_path__ + "static/media/Ideate_4.06570ad2.jpg";